import request from '../../requests/requests';
import { Api } from '../../config/api';
import { configs } from '../../config/config';

export function getBatteryEventByImei(data){
    return request({
        url:Api.battery_event.list+data.imei,
        method:configs.http.request.methodGet,
        data
    })
}